"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagAD = function FlagAD(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-56.47,146.36H-185.94A7.06,7.06,0,0,1-193,139.3V-114.94a7.06,7.06,0,0,1,7.06-7.06H-56.47Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "137.53",
    y: "1",
    width: "136.53",
    height: "268.36",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M209.54,146.36H80.07V-122H209.54a7.06,7.06,0,0,1,7.06,7.06V139.3a7.06,7.06,0,0,1-7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M59.82,35.13a3.71,3.71,0,0,0-3.72-3.71,3.57,3.57,0,0,0-1.26.24C53,30,49.68,26,53,20.24a2.65,2.65,0,1,0,2.5-4.6c2.75-1.4,6.66-4.37,6.46-9.93-.29-7.88-6.74-12.23-10.7-10.49,0-.11,0-.22,0-.33a2.63,2.63,0,0,0-2.63-2.63,2.61,2.61,0,0,0-2.15,1.12c-.16-.78-.14-2.25,1.69-3.83,3.4-2.94,7.27-10,.23-14.92-3.9-2.74-11.35-4.06-13.84-.31a3.26,3.26,0,0,0,1,4.48c-2,1.11-5.77,2.77-8.75,1.47-4.26-1.85-1.8-5.54-.85-7.19,1.66-2.9.61-7.65-5-7.65-3.71,0-5.57,3.71-9.28,3.71s-5.57-3.71-9.28-3.71c-5.57,0-6.61,4.75-4.95,7.65,1,1.65,3.41,5.34-.85,7.19-3,1.3-6.76-.36-8.75-1.47a3.27,3.27,0,0,0,1-4.48c-2.49-3.75-9.94-2.43-13.84.31-7,4.94-3.17,12,.23,14.92,1.83,1.58,1.85,3,1.69,3.83a2.61,2.61,0,0,0-2.15-1.12,2.62,2.62,0,0,0-2.63,2.63c0,.11,0,.22,0,.33-4-1.74-10.41,2.61-10.7,10.49-.2,5.56,3.71,8.53,6.46,9.93a2.65,2.65,0,0,0-1.79,2.51A2.66,2.66,0,0,0-31,20.81a2.58,2.58,0,0,0,1.63-.57c3.34,5.73,0,9.78-1.82,11.42a3.57,3.57,0,0,0-1.26-.24,3.71,3.71,0,0,0-3.72,3.71,3.71,3.71,0,0,0,3.35,3.68c-2.56,2.62-4.86,8.42.13,15C-27.29,61-14.3,60.42-8,60.65A13.88,13.88,0,0,1,.59,64.34,3.69,3.69,0,0,0,2,71.15a3.69,3.69,0,0,0,6.49-.38,20.42,20.42,0,0,0,3.3,2.29,20.42,20.42,0,0,0,3.3-2.29,3.69,3.69,0,0,0,6.49.38A3.69,3.69,0,0,0,23,64.34a13.85,13.85,0,0,1,8.62-3.69c6.26-.23,19.25.35,24.7-6.85,5-6.57,2.69-12.37.14-15a3.71,3.71,0,0,0,3.34-3.68Zm0,0",
    transform: "translate(194 123)",
    fill: "#dcbe82"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-21.61-12.54V41.28A11.13,11.13,0,0,0-10.47,52.41H4.38c5.57,0,7.42,3.71,7.42,3.71s1.86-3.71,7.42-3.71H34.07A11.13,11.13,0,0,0,45.21,41.28V-12.54a1.86,1.86,0,0,0-1.86-1.85h-63.1a1.86,1.86,0,0,0-1.86,1.85Zm0,0",
    transform: "translate(194 123)",
    fill: "#d2aa73"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "176.1",
    y: "112.32",
    width: "27.84",
    height: "27.84",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10,48.7A27.84,27.84,0,0,1-17.9,20.87H10Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M13.66,48.7V20.87H41.49A27.83,27.83,0,0,1,13.66,48.7Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "207.66",
    y: "112.32",
    width: "3.98",
    height: "27.84",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "211.63",
    y: "112.32",
    width: "3.98",
    height: "27.84",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "215.61",
    y: "112.32",
    width: "3.98",
    height: "27.84",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "219.59",
    y: "112.32",
    width: "3.98",
    height: "27.84",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "223.56",
    y: "112.32",
    width: "3.98",
    height: "27.84",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "231.51",
    y: "112.32",
    width: "3.98",
    height: "27.84",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "227.54",
    y: "112.32",
    width: "3.98",
    height: "27.84",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "185.38",
    y: "143.87",
    width: "3.09",
    height: "27.84",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "188.48",
    y: "143.87",
    width: "3.09",
    height: "27.84",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "194.67",
    y: "143.87",
    width: "3.09",
    height: "27.84",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "191.57",
    y: "143.87",
    width: "3.09",
    height: "27.84",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "200.85",
    y: "143.87",
    width: "3.09",
    height: "27.84",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "197.76",
    y: "143.87",
    width: "3.09",
    height: "27.84",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-14.8,47.29V20.87h-3.1V41.28a7.4,7.4,0,0,0,3.1,6Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-11.71,48.58V20.86H-14.8V47.29a7.33,7.33,0,0,0,3.09,1.29Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-11.71,20.87V48.58a8.4,8.4,0,0,0,1.24.12h1.86V20.87Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-13.74,15.57a.7.7,0,0,1-.41-.12C-16,14.25-16.08,13-16,12.34a2.31,2.31,0,0,1,1.64-1.83,2.08,2.08,0,0,1,2.2.66C-11,12.51-9.8,13-8.8,12.66A1.92,1.92,0,0,0-7.53,11a.73.73,0,0,1,.73-.73.73.73,0,0,1,.73.73,3.4,3.4,0,0,1-2.22,3c-.94.34-2.83.55-5-1.92a.61.61,0,0,0-.68-.2.83.83,0,0,0-.61.65c-.07.5.36,1.11,1.2,1.66a.74.74,0,0,1,.21,1,.74.74,0,0,1-.61.32Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M5.88,15.57a.72.72,0,0,1-.61-.32.74.74,0,0,1,.21-1c.84-.55,1.27-1.16,1.19-1.66a.82.82,0,0,0-.6-.65.63.63,0,0,0-.68.2c-2.13,2.48-4,2.26-5,1.92a3.4,3.4,0,0,1-2.22-3,.73.73,0,0,1,.73-.73A.73.73,0,0,1-.33,11,1.93,1.93,0,0,0,.93,12.66c1,.38,2.19-.15,3.35-1.49a2.07,2.07,0,0,1,2.19-.66,2.31,2.31,0,0,1,1.65,1.84c.1.64,0,1.9-1.84,3.1a.72.72,0,0,1-.4.12Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-14.15,16.44a.73.73,0,0,1-.44-.15.73.73,0,0,1-.14-1L1.16-5.63a3.26,3.26,0,0,0,.28-1.09A3.14,3.14,0,0,1,3-9.32a2.42,2.42,0,0,1,2.59.05A2.84,2.84,0,0,1,6.87-6.62,2.83,2.83,0,0,1,4.78-4.27a.72.72,0,0,1-.93-.43.73.73,0,0,1,.43-.94c.48-.18,1.07-.52,1.14-1.14A1.37,1.37,0,0,0,4.77-8a.91.91,0,0,0-1,0c-.66.4-.73.83-.84,1.56a4.4,4.4,0,0,1-.51,1.68l-15.94,21a.72.72,0,0,1-.58.29Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-3.88-6.54l-7.3,8.77L-8.26,11H.51L3.44,2.23Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-3.88-7.68-12,2.07l3.22,9.66H1L4.26,2.07ZM-10.36,2.39l5.75-6.91V10.27H-7.73ZM0,10.27H-3.15V-4.52L2.61,2.39Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M34.65,29.66,34.76,28s1.44-1,.74-2S34,24.9,32.29,25.12s-4.35.18-5.49.26-1.74.7-3.54.18l.47-1.1a4.59,4.59,0,0,0-1.36.33c-.28.14-1-.77-1.62-.63s-1.32,1.51-2.36,2.22l.55,1.1a1.24,1.24,0,0,1,1.11,0,1.92,1.92,0,0,0,1.44.55l.51.22A1.94,1.94,0,0,0,22.59,30s-.88,1.15-.77,1.33A22,22,0,0,1,23,33.75l.67-1.26s-1-.88-.81-1,.84-.26.73-.55.52,0,1.22.14A4.12,4.12,0,0,0,25,32.34a2.18,2.18,0,0,1,.33,1.37.9.9,0,0,1-.58.81l1,.3s.26-.37.45-.34c0,0-.08-3,.33-3.53,0,0,2.39.48,3.5-.11a1.77,1.77,0,0,0,.42.34c-.11.26-.21.52-.17.59a.27.27,0,0,0,.47,0c0-.07.07-.21.11-.36a1.87,1.87,0,0,0,.45.1,1,1,0,0,0,0,.5.28.28,0,0,0,.43-.18c0-.07,0-.19,0-.33a2.54,2.54,0,0,0,.62-.11l-1.26,2.06-.62.26.81.41.74-.3a4.7,4.7,0,0,1,1.84-2.28s.77,1.84-.18,2.84l.84.48.41-.85a6,6,0,0,1,.4-2.73Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M20.77,24.39a1.79,1.79,0,0,1-.47-.82c-.09-.46-.2-.66-.61-.79a1.06,1.06,0,0,1,.22.76c0,.46,0,1.09.26,1.29Zm0,0",
    transform: "translate(194 123)",
    fill: "#4173cd"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M24,25.69a5,5,0,0,1-2,2.6l-.51-.22a5.83,5.83,0,0,0,1.77-2.51Zm0,0",
    transform: "translate(194 123)",
    fill: "#4173cd"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M21.47,24.79c0-.05.65-.25.48-.81s-.17-1,.17-1.22a1.57,1.57,0,0,0,.29.76,1.16,1.16,0,0,1,0,1.46s-.42.33-.92-.19Zm0,0",
    transform: "translate(194 123)",
    fill: "#4173cd"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M21.55,29.84a.18.18,0,0,1-.08-.24l.22-.46a.57.57,0,0,0-.21-.74.55.55,0,0,0-.78.24l-.23.47a.18.18,0,0,1-.24.08l-.14.28.45.23h0a.26.26,0,0,0,.11.32.24.24,0,0,0,.31-.11h0l.45.22Zm0,0",
    transform: "translate(194 123)",
    fill: "#4173cd"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M23.34,33l.55.11-.46,1.43L23,33.75Zm0,0",
    transform: "translate(194 123)",
    fill: "#4173cd"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M24.7,34.52l-.35.6h1.34v-.3Zm0,0",
    transform: "translate(194 123)",
    fill: "#4173cd"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M31.26,34.08v.35H29.75l.73-.73Zm0,0",
    transform: "translate(194 123)",
    fill: "#4173cd"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M33.65,34.34l-.74.74h1.57l0-.26Zm0,0",
    transform: "translate(194 123)",
    fill: "#4173cd"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M34.65,41.2l.11-1.62s1.44-1,.74-2-1.52-1.14-3.21-.92-4.35.19-5.49.26-1.74.7-3.54.18l.47-1.1a4.59,4.59,0,0,0-1.36.33c-.28.14-1-.77-1.62-.63s-1.32,1.51-2.36,2.22l.55,1.1a1.21,1.21,0,0,1,1.11,0,1.92,1.92,0,0,0,1.44.55l.51.22a1.94,1.94,0,0,0,.59,1.73s-.88,1.15-.77,1.33A22,22,0,0,1,23,45.3L23.63,44s-1-.88-.81-1,.84-.26.73-.55.52,0,1.22.14A4.12,4.12,0,0,0,25,43.89a2.18,2.18,0,0,1,.33,1.37.9.9,0,0,1-.58.81l1,.3S26,46,26.14,46c0,0-.08-3.07.33-3.54,0,0,2.39.47,3.5-.11a1.77,1.77,0,0,0,.42.34c-.11.26-.21.52-.17.59a.28.28,0,0,0,.47,0c0-.07.07-.22.11-.37a1.87,1.87,0,0,0,.45.1,1,1,0,0,0,0,.5.27.27,0,0,0,.43-.18c0-.07,0-.19,0-.32a3.2,3.2,0,0,0,.62-.12L31.07,45l-.62.26.81.41.74-.3a4.7,4.7,0,0,1,1.84-2.28s.77,1.84-.18,2.84l.84.48.41-.85a6,6,0,0,1,.4-2.73Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M20.77,35.94a1.79,1.79,0,0,1-.47-.82c-.09-.46-.2-.66-.61-.79a1.09,1.09,0,0,1,.22.76c0,.46,0,1.09.26,1.29Zm0,0",
    transform: "translate(194 123)",
    fill: "#4173cd"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M24,37.24a5,5,0,0,1-2,2.6l-.51-.22a5.83,5.83,0,0,0,1.77-2.51Zm0,0",
    transform: "translate(194 123)",
    fill: "#4173cd"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M21.47,36.34c0-.05.65-.25.48-.81s-.17-1,.17-1.22a1.57,1.57,0,0,0,.29.76,1.16,1.16,0,0,1,0,1.46s-.42.33-.92-.19Zm0,0",
    transform: "translate(194 123)",
    fill: "#4173cd"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M21.55,41.39a.18.18,0,0,1-.08-.24l.22-.45a.58.58,0,0,0-.21-.75.56.56,0,0,0-.78.24l-.23.47a.17.17,0,0,1-.24.08l-.14.28.45.23h0a.25.25,0,0,0,.11.31.24.24,0,0,0,.31-.11h0l.45.22Zm0,0",
    transform: "translate(194 123)",
    fill: "#4173cd"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M23.34,44.5l.55.11L23.43,46,23,45.3Zm0,0",
    transform: "translate(194 123)",
    fill: "#4173cd"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M24.7,46.07l-.35.6h1.34v-.3Zm0,0",
    transform: "translate(194 123)",
    fill: "#4173cd"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M31.26,45.63V46H29.75l.73-.73Zm0,0",
    transform: "translate(194 123)",
    fill: "#4173cd"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M33.65,45.89l-.74.74h1.57l0-.26Zm0,0",
    transform: "translate(194 123)",
    fill: "#4173cd"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagAD;
exports["default"] = _default;